import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'

import { setValue, setSymbol } from './order-currency-slice'
import { fetchExchangeRate } from './order-currency-exchange-rate-thunk'

const useOrderCurrency = () => {
  const { value, exchangeRate, symbol, loading, error } = useSelector(
    (state: RootState) => state.order.currency,
  )

  const dispatch = useDispatch<TypedDispatch<RootState>>()

  const _setValue = useCallback(
    (defaultCurrency: string) => {
      dispatch(setValue(defaultCurrency))
    },
    [dispatch],
  )

  const _setSymbol = useCallback(
    (symbol: string) => {
      dispatch(setSymbol(symbol))
    },
    [dispatch],
  )

  const _updateExchangeRate = useCallback(
    async (newCurrency: string) => {
      dispatch(fetchExchangeRate(newCurrency))
    },
    [dispatch],
  )

  return useMemo(
    () => ({
      value,
      exchangeRate,
      symbol,
      loading,
      error,
      setValue: _setValue,
      setSymbol: _setSymbol,
      updateExchangeRate: _updateExchangeRate,
    }),
    [
      value,
      exchangeRate,
      symbol,
      loading,
      error,
      _setValue,
      _setSymbol,
      _updateExchangeRate,
      dispatch,
    ],
  )
}

export default useOrderCurrency
